"use strict";import{html as r}from"@cisco-u/base";export function sleekRectangle({height:e=277,width:l=252,hidden:t=!1,title:a="",fill:i="#C3C4C5"}={}){return r`<svg
    width=${l}
    height=${e}
    viewBox="0 0 252 277"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${t?"true":"false"}"
    aria-label="${a}"
  >
    <path
      d="M1.07643 94.0914C1.38533 42.1262 43.7619 0.250415 95.7271 0.559317L251.782 1.48697L250.705 182.556C250.396 234.521 208.02 276.397 156.054 276.088L7.96138e-05 275.16L1.07643 94.0914Z"
      fill=${i}
    />
  </svg>`}
//# sourceMappingURL=sleek-rectangle.js.map
